module.exports = __webpack_public_path__ + "static/media/promotwo.58c6d824.png";